import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const FALLBACK_LANG = 'it';
export const SUPPORTED_LANGUAGES = ['it', 'en'];

i18n
  .use(Backend)
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    backend: {
      loadPath: '/assets/cedolauto/locales/{{lng}}/{{ns}}.json',
    },
    // react: {
    //   useSuspense: false,
    // },
    detection: {
      order: [
        'querystring',
        'localStorage',
        'cookie',
        'navigator',
        'htmlTag',
        'path',
        'subdomain',
      ],
      lookupQuerystring: 'language',
    },
    // COMMENT: LET'S CONSIDER THIS SO WE DON'T LET i18n TRY FETCH THE DEFAULT "en-GB" bundle
    supportedLngs: SUPPORTED_LANGUAGES,
    // nonExplicitSupportedLngs: true, // omit en-US
    //nsSeparator: '_',
    load: 'unspecific',
    fallbackLng: FALLBACK_LANG,
    // debug: true,
    returnEmptyString: false,

    // default namespace (needs no prefix on calling t)
    ns: 'translation',
    defaultNS: 'translation',

    preload: ['it', 'en'],

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
